// Copyright (c) Ensho Health, 2021 to present

import api from '../api';
import actions from './index.js';
import { setNotification, NOTIFICATION_TYPES } from './notification.action.js';
import { formatFilters } from './actions.utils.js';

const PREFIX = 'patient';
export const ACTION_TYPES = {
  SET_DETAIL: `${PREFIX}-SET_DETAIL`,
  SET_HISTORY: `${PREFIX}-SET_HISTORY`,
  SET_FILTERS: `${PREFIX}-SET_FILTERS`,
  RESET_FILTERS: `${PREFIX}-RESET_FILTERS`,
  RESET_OFFSET: `${PREFIX}-RESET_OFFSET`,
  RESET_HISTORY_OFFSET: `${PREFIX}-RESET_HISTORY_OFFSET`,
  RESET_PATIENT: `${PREFIX}-RESET_PATIENT`,
  LOADING: `${PREFIX}-LOADING`,
  LOADING_HISTORY: `${PREFIX}-LOADING_HISTORY`,
  ERROR: `${PREFIX}-ERROR`
};

export function fetchPatient(patientId) {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: ACTION_TYPES.LOADING });
      const res = await api.patient.fetchPatient(patientId);
      const state = getState();
      dispatch({
        type: actions.pii.ACTION_TYPES.ADD_PATIENTS,
        payload: [res.patientId]
      });
      if (!state.pii.pii[res.patientId]?.piiFetched) {
        await dispatch(actions.pii.fetchPii());
      }
      dispatch({ type: ACTION_TYPES.SET_DETAIL, payload: res });
    } catch (error) {
      console.error(error.message);
      dispatch(
        setNotification({
          type: NOTIFICATION_TYPES.ERROR,
          serverMessage: error.message,
          info: {
            location: 'patient.action.fetchPatient',
            patientId: patientId
          },
          display: `Error while fetching patient information ${patientId} `
        })
      );
      dispatch({ type: ACTION_TYPES.ERROR, payload: error.message });
    }
  };
}

export function fetchHistory(patientId) {
  return async (dispatch, getState) => {
    try {
      let state = getState();
      dispatch({ type: ACTION_TYPES.LOADING_HISTORY });

      const res = await api.labResult.fetchResults(
        formatFilters(state.patient.historyFilters),
        state.patient.historyOffset,
        state.patient.historyLimit,
        patientId
      );
      dispatch({
        type: ACTION_TYPES.SET_HISTORY,
        payload: res
      });
    } catch (error) {
      console.error(error.message);
      dispatch(
        setNotification({
          type: NOTIFICATION_TYPES.ERROR,
          serverMessage: error.message,
          info: {
            location: 'patient.action.fetchHistory',
            patientId: patientId
          },
          display: `Error while fetching patient history ${patientId} `
        })
      );
      dispatch({ type: ACTION_TYPES.ERROR, payload: error.message });
    }
  };
}

export function resetOffset() {
  return { type: ACTION_TYPES.RESET_OFFSET };
}

export function resetHistoryOffset() {
  return { type: ACTION_TYPES.RESET_HISTORY_OFFSET };
}

export function resetPatient() {
  return { type: ACTION_TYPES.RESET_PATIENT };
}

// set the patient history filters that must be saved in the state manager for
// persistence across several pages
export function setFilters(filters) {
  return { type: ACTION_TYPES.SET_FILTERS, payload: filters };
}

// reset the patient history filters
export function resetFilters() {
  return { type: ACTION_TYPES.RESET_FILTERS };
}
